import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-content-popup',
  templateUrl: './content-popup.component.html',
  styleUrls: ['./content-popup.component.scss']
})
export class ContentPopupComponent {

  public msg: string ='';
  public title: string = ''
  public buttonName: string = 'ok'
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ContentPopupComponent>,
  ) {
    this.msg = data.msg;
    this.title = data.title;
    this.buttonName = data.buttonName;
  }

  onButtonClick() {
    this.dialogRef.close(true);
  }

}
